import { createTheme } from "@mui/material";

import styles from "../global.scss";

export const theme = createTheme({
    typography: {
        // fontFamily: "urbanist",
        fontFamily: "Plus Jakarta Sans",
        h1: {
            fontWeight: 900,
            fontSize: "72px",
            color: styles["secondary_dark"]
        },
        h2: {
            fontWeight: 800,
            fontSize: "56px",
            color: styles["secondary_dark"]
        },
        h3: {
            fontWeight: 700,
            fontSize: "38px",
            color: styles["secondary_dark"]
        },
        h4: {
            fontWeight: 600,
            fontSize: "28px",
            color: styles["secondary_dark"]
        },
        h5: {
            fontWeight: 600,
            fontSize: "24px",
            color: styles["secondary_dark"]
        },
        h6: {
            fontWeight: 600,
            fontSize: "18px",
            color: styles["secondary_dark"]
        },
        subtitle1: {
            fontWeight: 500,
            fontSize: "16px",
            color: styles["secondary_dark"]
        },
        subtitle2: {
            fontWeight: 500,
            fontSize: "15px",
            color: styles["secondary_dark"]
        },
        body1: {
            fontWeight: 400,
            fontSize: "14px", 
            color: styles["secondary_dark"]
        },
        body2: {
            fontWeight: 400,
            fontSize: "13px",
            color: styles["secondary_dark"]
        },
        button: {
            fontWeight: 400,
            fontSize: "13px",
            color: styles["secondary_dark"]
        },
        caption: {
            fontWeight: 400,
            fontSize: "12px",
            color: styles["secondary_dark"]
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: "none",
                    textTransform: "none",
                    fontWeight: "600",
                    borderRadius: "12px",
                    minWidth: "120px",
                    // minHeight: "45px",
                    minHeight: "37.13px",
                },
                text: {
                    backgroundColor: styles["primary_light"],
                    color: styles["secondary_dark"],
                    "&:hover": {
                        backgroundColor: styles["primary"]
                    }
                },
                contained: {
                    backgroundColor: styles["secondary"],
                    color: styles["primary_light"],
                    // color: "black",
                    // elevation: 0,
                    "&:hover": {
                        // backgroundColor: styles["secondary_light"]
                        backgroundColor: "#2175ea"
                    }
                },
                outlined: {
                    borderColor: "#b5b5b5",
                    color: styles["secondary_dark"],
                    "&:hover": {
                        backgroundColor: styles["primary_light"]
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: "12px",
                    borderColor: "red",
                },
            }
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: "grey"
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: "12.5px",
                    color: "grey"
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    borderRadius: "12px",
                },
            }
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    background: "rgba( 140, 140, 140, 0.1 )",
                    boxShadow: "0 8px 32px 0 rgba( 31, 38, 135, 0.37 )",
                    "backdrop-filter": "blur( 2px )",
                    "-webkit-backdrop-filter": "blur( 2px )",
                }
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    fontSize: "14px",
                    cursor: 'pointer',
                    '&[disabled]': {
                      color: "grey",
                      textDecoration: "none",
                      pointerEvents: 'none',
                    },
                },
            }
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    color: "grey",
                    backgroundColor: "#fafafa",
                    borderColor: "#fafafa",
                    padding: "8px 16px",
                },
                body: {
                    borderColor: "#f1f1f1",
                    padding: "8px 16px",
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                //    color: "red"
                },
                selectLabel: {
                    color: "grey"
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    minHeight: "40px",
                    height: "40px",
                    maxHeight: "40px",
                    marginBottom: "10px"
                },
                indicator: {
                    bottom: "0px",
                    height: "0px",
                    backgroundColor: styles['secondary']
                },
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontWeight: "600",
                    minHeight: "40px",
                    height: "40px",
                    maxHeight: "40px",
                    borderRadius: "12px",
                    marginRight: "10px",
                    "&:hover": {
                        backgroundColor: "#f1f1f1",
                    },
                    "&.Mui-selected": {
                        color: styles['secondary'],
                        backgroundColor: styles['primary_light'],
                    }
                },
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: "#fafafa"
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    padding: 6,
                },
                thumb: {
                    backgroundColor: styles["secondary_light"],
                    boxShadow: 'none',
                    width: 18,
                    height: 18,
                    margin: 1,
                },
                track: {
                    border: "1.5px solid",
                    borderColor: styles["secondary"],
                    backgroundColor: "white",
                    borderRadius: 26 / 2,
                    '&::before, &::after': {
                        content: '""',
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: 18,
                        height: 18,
                    },
                },
            }
        },
        MuiChip: {
            styleOverrides: {
                labelSmall: {
                    fontSize: "12px"
                },
                filled: {
                    fontWeight: 500,
                    "&.MuiChip-colorError": {
                        backgroundColor: "#fadfd8",
                        color: "#b24020"
                    },
                    "&.MuiChip-colorSuccess": {
                        backgroundColor: "#d7ebce",
                        color: "#44712e"
                    },
                    "&.MuiChip-colorInfo": {
                        backgroundColor: "#dce6f1",
                        color: "#004182"
                    },
                    "&.MuiChip-colorWarning": {
                        backgroundColor: "#fce2ba",
                        color: "#915907"
                    },
                    "&.MuiChip-colorAdmin": {
                        backgroundColor: "#fce2ba",
                        color: "#915907"
                    }
                },
                outlined: {
                    fontWeight: 500,
                    "&.MuiChip-colorError": {
                        backgroundColor: "#fadfd8",
                        color: "#b24020"
                    },
                    "&.MuiChip-colorSuccess": {
                        backgroundColor: "#d7ebce",
                        color: "#44712e"
                    },
                    "&.MuiChip-colorInfo": {
                        backgroundColor: "#dce6f1",
                        color: "#004182"
                    },
                    "&.MuiChip-colorWarning": {
                        backgroundColor: "#fce2ba",
                        color: "#915907"
                    },
                },
            }
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    minWidth: "200px",
                    maxWidth: "500px"
                }
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    borderRadius: "12px",
                    minHeight: "53.13px",
                    padding: "11px 20px",
                    fontWeight: "600",
                    fontSize: "14px",
                },                
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    borderRadius: "12px",
                    boxShadow: "none",
                    backgroundColor: "#f1f1f1"
                }
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    borderRadius: "12px",
                }
            }
        }
    }
})